// extracted by mini-css-extract-plugin
module.exports = {"Emojify":"bbi_a bhj_g"};